import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

import { buildFields } from '../base/builders/buildValidationFields';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();
    const {
        financial_work_cost_month,
        name,
        opex,
        opex_cost_ranges_kw,
        opex_costing_type,
        opex_percentage_increase,
        parameters,
        parameters_commission_credit,
        parameters_hitch,
        parameters_rate,
        work_cost_ranges,
    } = buildFields();

    return object().shape({
        api_key: string().when('type_algorithm', {
            is: 'ppa_api_key',
            then: () => string().required(REQUIRED_TEXT),
            otherwise: () => string().nullable(),
        }),
        financial_work_cost_month,
        name,
        opex,
        opex_cost_ranges_kw,
        opex_costing_type,
        opex_percentage_increase,
        parameters: object().shape({
            tax: parameters.tax,
            terms: parameters.terms,
        }),
        parameters_commission_credit,
        parameters_hitch,
        parameters_rate,
        work_cost_ranges,
    });
};
